module.exports = __webpack_public_path__ + "img/image_banner.298a3797.png";